<template>
  <div>
    <div class="w-100 d-inline-block pets-banner-slider">
      <div class="container autoContent">
        <div class="row margin-top-4 margin-bottom-4">
          <div class="col-xl-4 col-12 col-sm-6 col-md-6 col-lg-5">
             <div class="w-100 d-inline-block">
               <p class="mb-0 text-size-14 nav-color family-filson-medium w-55 w-xs-100 w-sm-100 w-md-100 w-ipad-100 text-full-13">
                 First-Class Grooming For Your Furry Friend
               </p>
               <h1 class="half-black fw-bold text-full-24 fw-bold filson-black-family margin-top-1 margin-bottom-1 text-size-20">
                 Book Mobile pet grooming services in Dubai 
               </h1>
               <p class="mb-0 text-size-14 text-black family-inter-light text-full-11">
                 Are you a pet owner and searching for the best mobile pet grooming services in Dubai? The Dubai Pets Groomer is one of the best mobile pet grooming service providers in Dubai, with a comfortable environment, professional pet groomers, and modern facilities that will pamper your pet with extra care. We deeply understand the attachment you have to your pets, so we care for and groom them with love.
               </p>
               <div class="w-100 d-inline-block text-xs-center margin-top-3 margin-bottom-2">
                <router-link class="text-white text-size-12 d-inline-block book-online-btn border-green bg-green inter-bold-family me-2 text-full-11 w-xs-100 text-xs-center" to="/booking/">
                  <img src="@/assets/images/book-online-icon.svg" alt="picture" class="me-2 h-16">
                  BOOK NOW
              </router-link>
            </div>
             </div>
          </div>
          <div class="col-xl-4 col-12 d-xl-block d-none d-md-block d-sm-block d-lg-block col-sm-6 col-md-6 col-lg-2">
             <div class="w-80 w-xs-100 w-sm-100 w-md-100 w-ipad-100 d-inline-block">
               <img class="w-100" v-lazy="require('@/assets/images/pet-grooming-pet-groomer-mobile-pet-grooming.webp')" alt="pet grooming, pet groomer, mobile pet grooming">
             </div>
          </div>
          <div class="col-xl-4 col-12 col-sm-12 col-md-12 col-lg-5">
             <div class="row margin-bottom-3 margin-xl-top-0">
               <div class="col-xl-4 col-4 col-sm-3 col-md-2 col-lg-2">
                 <div class="w-100 d-inline-block service-rabbit-groom-box">
                   <span class="d-inline-block w-100">
                     <img class="w-100" v-lazy="require('@/assets/images/cute-dog-icon.webp')" alt="picture">
                   </span>
                 </div>
               </div>
               <div class="col-xl-8 ps-xl-0 col-8 col-sm-9 col-md-9 col-lg-9">
                 <div class="w-100 d-inline-block">
                   <p class="mb-0 text-size-14 fw-bold text-black family-filson-bold text-uppercase text-full-13">
                     Dog Grooming
                   </p>
                   <p class="mb-0 text-size-14 text-black family-inter-light service-rabbit-content 
                   text-full-12">
                    Let us help you to keep your puppy paw-some all year round.
                   </p>
                     <router-link class="fw-bold text-size-14 nav-color inter-bold-family text-full-12" to="/services/mobile-dog-grooming-dubai-pet-groomer/">
                      Book Now
                      <i class="fa fa-arrow-right ms-1" aria-hidden="true"></i>
                    </router-link>
                 </div>
               </div>
             </div>
             <div class="row margin-bottom-3">
               <div class="col-xl-4 col-4 col-sm-3 col-md-2 col-lg-2">
                 <div class="w-100 d-inline-block service-rabbit-groom-box">
                   <span class="d-inline-block w-100">
                     <!-- <img class="w-100" src="@/assets/images/cute-cat-icon.webp" alt="picture"> -->
                     <img class="w-100" v-lazy="require('@/assets/images/cute-cat-icon.webp')" alt="picture">
                   </span>
                 </div>
               </div>
               <div class="col-xl-8 ps-xl-0 col-8 col-sm-9 col-md-9 col-lg-9">
                 <div class="w-100 d-inline-block">
                   <p class="mb-0 text-size-14 fw-bold text-black family-filson-bold text-uppercase text-full-13">
                     Cats Grooming
                   </p>
                   <p class="mb-0 text-size-14 text-black family-inter-light service-rabbit-content 
                   text-full-12">
                     Let's keep your kitty looking neat and clean with our grooming service.
                   </p>
                     <router-link class="fw-bold text-size-14 nav-color inter-bold-family text-full-12" to="/services/mobile-cat-grooming-service-dubai/">
                      Book Now
                      <i class="fa fa-arrow-right ms-1" aria-hidden="true"></i>
                    </router-link>
                 </div>
               </div>
             </div>
             <div class="row margin-bottom-3">
               <div class="col-xl-4 col-4 col-sm-3 col-md-2 col-lg-2">
                 <div class="w-100 d-inline-block service-rabbit-groom-box">
                   <span class="d-inline-block w-100">
                     <!-- <img class="w-100" src="@/assets/images/cute-rabbit-icon.webp" alt="picture"> -->
                     <img class="w-100" v-lazy="require('@/assets/images/cute-rabbit-icon.webp')" alt="picture">
                   </span>
                 </div>
               </div>
               <div class="col-xl-8 ps-xl-0 col-8 col-sm-9 col-md-9 col-lg-9">
                 <div class="w-100 d-inline-block">
                   <p class="mb-0 text-size-14 fw-bold text-black family-filson-bold text-uppercase text-full-13">
                     Rabbits Grooming
                   </p>
                   <p class="mb-0 text-size-14 text-black family-inter-light service-rabbit-content 
                   text-full-12">
                     We keep your pet looking its best and adorable with a personal touch.
                   </p>
                    <router-link class="fw-bold text-size-14 nav-color inter-bold-family text-full-12" to="/services/rabbit-grooming-dubai-mobile-pet-groomer/">
                      Book Now
                      <i class="fa fa-arrow-right ms-1" aria-hidden="true"></i>
                    </router-link>
                 </div>
               </div>
             </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'serviceBannerComponent',
}
</script>

<style scoped>

</style>
